import Rebase from 're-base';
import Firebase from 'firebase';

var App = Firebase.initializeApp({
    apiKey: "AIzaSyB3oRQIuSJQUF5WXC40mfp3y1VxgyU-59M",
    authDomain: "rebeccaandmatthew-57703.firebaseapp.com",
    databaseURL: "https://rebeccaandmatthew-57703.firebaseio.com",
    projectId: "rebeccaandmatthew-57703",
    storageBucket: "rebeccaandmatthew-57703.appspot.com",
    messagingSenderId: "813523112303"
  });
var Base = Rebase.createClass(App.database());

export default Base;
export {App};


// WEBPACK FOOTER //
// ./src/rebase.js